














import { Vue, Component, Prop } from 'nuxt-property-decorator'
import { defineComponent } from '@nuxtjs/composition-api'
import CardOffice from '@/components/Cards/CardOffice.vue'

@Component({})
class CardOfficeList extends Vue {
  @Prop() readonly list: ReadonlyArray<any> = []
  @Prop() readonly popup: boolean = false
  static options: any
}

export default defineComponent({
  name: 'CardOfficeList',
  components: {
    CardOffice,
  },
  props: CardOfficeList.options.props,
  setup() {},
})
